import React, { Component, useEffect, useState,lazy } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import  '../assets/css/schedule.css'
import { authRef } from "../config/firebase";
import { connect, useSelector, useDispatch } from "react-redux";
import { checkLogin } from "../actions";

import Login from "../containers/login";
import LayoutPrincipal from "./layout_principal";
import Inicio from "../components/inicio";

const Inventary = lazy(() => import(`../containers/c_i_report_new`))
const InventaryNew = lazy(() => import(`../components/C&IReport`))
const Dashboard = lazy(() => import(`../containers/dashboard_new`))
const Home = lazy(() => import(`../components/home`))
const Enquiries = lazy(() => import(`../containers/enquiries`))
const Rooms = lazy(() => import(`../containers/rooms`))
const RoomsPrices = lazy(() => import(`../containers/rooms_prices`))
const Seasons = lazy(() => import(`../containers/seasons`))
const EnquiryForm = lazy(() => import(`../containers/enquiry_form`))
const CashBook = lazy(() => import(`../containers/cash_book`))

const Items = lazy(() => import(`../containers/items`))
const Clients = lazy(() => import(`../containers/clients`))
const Suppliers = lazy(() => import(`../containers/suppliers`))
const Medios = lazy(() => import(`../containers/medios`))
const Monedas = lazy(() => import(`../containers/monedas`))
const Rubros = lazy(() => import(`../containers/rubros`))
const SubRubros = lazy(() => import(`../containers/subrubros`))
const Sources = lazy(() => import(`../containers/sources`))
const Calendario = lazy(() => import(`../containers/calendario`))
const Informe = lazy(() => import(`../containers/informe`))
const Comisiones = lazy(() => import(`../containers/comisiones`))
const MeanPayments = lazy(() => import(`../containers/mean_payments`))
const Activities = lazy(() => import(`../components/activities`))
const ActivityFormats = lazy(() => import(`../components/activity_formats`))
const Receipts = lazy(() => import(`../components/receipts`))
const ActivityReport = lazy(() => import(`../containers/calendario_reporte_form`))
const Eventos = lazy(() => import(`../components/eventos`))
const YogaReports = lazy(() => import(`../containers/yoga_reports`))
//const CalendarioDisplay = lazy(() => import(`../components/yoga_schedule/CalendarioDisplay`))

const CalendarioDisplay = lazy(() => import(`../components/YogaSchedule`))
const Instructors = lazy(() => import(`../components/instructors`))
const Usuarios = lazy(() => import(`../containers/usuarios`))
const MenuAdmin = lazy(() => import(`../containers/menu_admin`))
const Reserva = lazy(() => import(`../containers/reserva`))
const Taxes = lazy(() => import(`../containers/taxes`))
const BNumbers = lazy(() => import(`../containers/b_numbers`))
const EnquiReport = lazy(() => import(`../containers/enqui_report`))
const OtrosEventos = lazy(() => import(`../components/otros_eventos`))
const Pay = lazy(() => import(`../components/payment_test`))
const Help = lazy(() => import(`../components/help`))
const Resumen = lazy(() => import(`../containers/resumen`))
const TareasPanel = lazy(() => import(`../components/tareas_panel`))
const Assets = lazy(() => import(`../components/assets`))
const AssetsTipos = lazy(() => import(`../components/assets_tipos`))
const Facturacion = lazy(() => import(`../components/facturacion`))
const ResumenFacturacion = lazy(() => import(`../components/resumen_facturacion`))
const Team = lazy(() => import(`../containers/team`))
const SurfReport = lazy(() => import(`../containers/surf_reports`))
const SurfStatistics = lazy(() => import(`../components/SurfStatistics`))
const BookingsCabecera = lazy(() => import(`../components/bookings_cabecera`))
const TravelInformation = lazy(() => import(`../containers/travel_information`))
const ReservaNew = lazy(() => import(`../containers/reserva_new`))
const Availability = lazy(() => import(`../containers/availability`))
const SurfInstructorReport = lazy(() => import(`../components/surf_instructors_report`))
const SurfInstructorReportNew = lazy(() => import(`../components/surf_instructors_report_new`))
const Reservas = lazy(() => import(`../containers/reservas_panel`))
const TiendaCategorias = lazy(() => import(`../containers/tienda_categorias`))
const TiendaProductos = lazy(() => import(`../containers/tienda_productos`))
const ReglasTemplate = lazy(() => import(`../containers/reglas_template`))
const OrdenesdPago = lazy(() => import(`../components/ordenes_pago`))
const OrdenesNuevas = lazy(() => import(`../components/OrdenesNuevas`))
const BankAccounts = lazy(() => import(`../components/BankAccounts`))
const Tickets = lazy(() => import(`../components/Tickets/tickets`))
const SupplierAct = lazy(() => import(`../components/supplier_act`))
const SupplierContrats = lazy(() => import(`../components/supplier_contracts`))
const SupplierrReceipts = lazy(() => import("../components/suppliers_receipts"))
const BookingCalendar = lazy(() => import(`../components/bookings_calendar`))
const Suscripciones = lazy(() => import(`../components/suscripciones`))
const ReceiptPdf = lazy(() => import(`../components/receipt_pdf`))
const ReceiptXls = lazy(() => import(`../components/receipt_xls`))
const LafiseTransactions = lazy(() => import(`../components/lafise_transactions`))
const SurfClassReport = lazy(() => import(`../components/surf_class_report`))
const SupplierReceiptsResume = lazy(() => import(`../containers/supplier_receipts_resume`))
const CalendarioEventos = lazy(() => import(`../components/calendario_eventos`))
const SupplierHoursPendings = lazy(() => import(`../containers/supplier_hours_pending`))
const CalendarioPdf = lazy(() => import(`../components/calendario_pdf`))
const Facturas = lazy(() => import(`../containers/facturas`))
const RestoStatistics = lazy(() => import(`../components/RestoStatistics`))
const Movimientos = lazy(() => import(`../components/Movimientos/Movimientos`))
const SupplierPaymentOrder = lazy(() => import(`../components/SupplierPaymentOrder`))
const YMPStatistics = lazy(() => import(`../containers/YMPStatistics`))
const BankStatement = lazy(() => import(`../containers/bank_statement`))
const GrillaICals = lazy(() => import(`../components/GrillaICals`))

function App(props) {
	const usuario = useSelector((state) => state.usuario)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(checkLogin())
	}, [])

	return  <BrowserRouter >
			<Routes>
				<Route path="/login" element={<Login/>} />
				<Route path="/" element={<LayoutPrincipal />}>
					<Route index element={<Inicio/>} />
					<Route path="enquiries" element={<Enquiries/>} />
					<Route path="rooms" element={<Rooms/>} />
					<Route path="rooms_prices" element={<RoomsPrices/>} />
					<Route path="seasons" element={<Seasons/>} />
					<Route path="enquiry/:pos" element={<EnquiryForm/>} />
					<Route path="cashbook" element={<CashBook/>} />
					<Route path="inventary" element={<Inventary/>} />
					<Route path="inventary_new" element={<InventaryNew/>} />
					<Route path="items" element={<Items/>} />
					<Route path="clients" element={<Clients/>} />
					<Route path="suppliers" element={<Suppliers/>} />
					<Route path="categories" element={<Rubros/>} />
					<Route path="subcategories" element={<SubRubros/>} />
					<Route path="medios" element={<Medios/>} />
					<Route path="monedas" element={<Monedas/>} />
					<Route path="sources" element={<Sources/>} />
					<Route path="dashboard" element={<Dashboard/>} />
					{/*<Route path="dashboard_new" element={<Dashboard/>} />*/}
					<Route path="calendario" element={<Calendario/>} />
					<Route path="informe" element={<Informe/>} />
					<Route path="comisiones" element={<Comisiones/>} />
					<Route path="mean_payments" element={<MeanPayments/>} />
					<Route path="activities" element={<Activities/>} />
					<Route path="activity_formats" element={<ActivityFormats/>} />
					<Route path="receipts" element={<Receipts/>} />
					<Route path="activity_report" element={<ActivityReport/>} />
					<Route path="events" element={<Eventos/>} />
					<Route path="other_events/:tipo" element={<OtrosEventos/>} />
					<Route path="yoga_reports" element={<YogaReports/>} />
					<Route path="surf_reports" element={<SurfReport/>} />
					<Route path="surf_statistics" element={<SurfStatistics/>} />
					<Route path="schedule_display" element={<CalendarioDisplay/>} />
					<Route path="instructors/:category" element={<Instructors/>} />
					<Route path="users" element={<Usuarios/>} />
					<Route path="menu_admin" element={<MenuAdmin/>} />
					<Route path="reserva/:id?" element={<Reserva/>} />
					<Route path="taxes" element={<Taxes/>} />
					<Route path="b_numbers" element={<BNumbers/>} />
					<Route path="enqui_report" element={<EnquiReport/>} />
					<Route path="pay" element={<Pay/>} />
					<Route path="help" element={<Help/>} />
					<Route path="resume" element={<Resumen/>} />
					<Route path="booking_search" element={<Home/>} />
					<Route path="tasks" element={<TareasPanel/>} />
					<Route path="assets" element={<Assets/>} />
					<Route path="assets_type" element={<AssetsTipos/>} />
					<Route path="facturacion" element={<Facturacion/>} />
					<Route path="resumen_facturacion" element={<ResumenFacturacion/>} />
					<Route path="team" element={<Team/>} />
					<Route path="reservation_admin" element={<BookingsCabecera/>} />
					<Route path="travel_information" element={<TravelInformation/>} />
					<Route path="booking_admin/:id_hotel/:id" element={<ReservaNew/>} />
					<Route path="availability" element={<Availability/>} />
					<Route path="surf_instructor_report" element={<SurfInstructorReport/>} />
					<Route path="surf_instructor_report_new" element={<SurfInstructorReportNew/>} />
					<Route path="reservas" element={<Reservas/>} />
					<Route path="tienda_categorias" element={<TiendaCategorias/>} />
					<Route path="tienda_productos" element={<TiendaProductos/>} />
					<Route path="reglas_templates" element={<ReglasTemplate/>} />
					<Route path="ordenes" element={<OrdenesdPago/>} />
					<Route path="ordenes_pago_new" element={<OrdenesNuevas/>} />
					<Route path="bank_accounts" element={<BankAccounts/>} />
					<Route path="tickets" element={<Tickets/>} />
					<Route path="supplier_act" element={<SupplierAct/>} />
					<Route path="supplier_contrats" element={<SupplierContrats/>} />
					<Route path="supplier_receipts" element={<SupplierrReceipts/>} />
					<Route path="supplier_receipts_resume" element={<SupplierReceiptsResume/>} />
					<Route path="booking_calendar" element={<BookingCalendar/>} />
					<Route path="suscripciones" element={<Suscripciones/>} />
					<Route path="receipt_pdf/:id" element={<ReceiptPdf/>} />
					<Route path="receipt_xls/:id" element={<ReceiptXls/>} />
					<Route path="lafise_transactions" element={<LafiseTransactions/>} />
					<Route path="surf_classes_report" element={<SurfClassReport/>} />
					<Route path="calendario_eventos/:tipo" element={<CalendarioEventos/>} />
					<Route path="supplier_hours_pendings" element={<SupplierHoursPendings />} />
					<Route path="calendario_pdf/:id" element={<CalendarioPdf/>} />
					<Route path="facturas" element={<Facturas/>} />
					<Route path="resto_statistics" element={<RestoStatistics/>} />
					<Route path="movimientos" element={<Movimientos/>} />
					<Route path="supplier_payment_orders" element={<SupplierPaymentOrder/>} />
					<Route path="ymp_statistics" element={<YMPStatistics/>} />
					<Route path="bank_statement" element={<BankStatement/>} />
					<Route path="grilla_icals" element={<GrillaICals/>} />
				</Route>
			</Routes>
		</BrowserRouter>
}

export default App